var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LV---Allar-Ferdabeidnir",
    transform: "translate(-22.000000, -379.000000)",
    stroke: "#939598",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(21.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_clipboard",
    transform: "translate(2.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "15 3 16 3 16 19 -9.09494702e-13 19 -9.09494702e-13 3 1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,2 C10,0.895 9.105,0 8,0 C6.895,0 6,0.895 6,2 L4,2 L4,6 L12,6 L12,2 L10,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,10 L12,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,14 L12,14",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboard);
export default __webpack_public_path__ + "static/media/icon-clipboard.e1deb39ef78cb2cf62bf8649b2aeab40.svg";
export { ForwardRef as ReactComponent };